import { Tune } from "@mui/icons-material";
import { Chip } from "@mui/material";
import ButtonOne from "../common/normal-button";
import { ColorsConstants } from "../cssUtils/constants";

const TableFilterButton = ({setFilterModalOpen, totalActiveFilters}) => {
  return (
    <ButtonOne
      variant="outlined"
      onClick={() => setFilterModalOpen(true)}
      startIcon={<Tune sx={{ color: ColorsConstants.primaryBackgroundColor }} />}
      // sx={{
      //   borderColor: "primary.main"
      // }}
      title="Filters"
    >
      
      {totalActiveFilters > 0 && (
        <Chip
          label={totalActiveFilters}
          size="small"
          color="primary"
          sx={{
            marginLeft: 1,
            height: 18,
            position: "absolute",
            bottom: -6,
            left: -12,
            fontSize: "0.6rem",
          }}
        />
      )}
    </ButtonOne>
  );
};

export default TableFilterButton;
